import React from "react";
import GaugeComponent from "react-gauge-component";

function Gauge({ value, status }) {
  const getColor = (remark) => {
    switch (remark) {
      case "Critical":
      case "Low":
        return "#d30d00";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#00960f";
      default:
        return "#f7a452";
    }
  };
  const getSubArcs = (value) => {
    const array = [];
    array.push({
      color: getColor(status),
      limit: value,
    });
    array.push({
      color: "#d6d6d6",
      limit: 100,
    });
    return array;
  };

  return (
    <div className=" flex flex-col">
      <div className="w-[85%] flex justify-center mx-auto relative ">
        <div className=" absolute top-[85px]">
          <p className="font-semibold  text-[32px] text-[#262626]">
            {value}%<span className=" text-sm text-[#737373]">/100%</span>
          </p>
        </div>
        <GaugeComponent
          type="semicircle"
          arc={{
            padding: 0.0,
            width: 0.1,
            subArcs: getSubArcs(value),
          }}
          pointer={{
            length: 0,
            type: "blob",
            animationDelay: 0,
            baseColor: "#3f3f3f",

            width: 12,
          }}
          labels={{
            valueLabel: {
              formatTextValue: (value) => `${value + 100}%`,
              style: {
                fontWeight: "bold",
                fontSize: 32,
                fill: "none",
                stroke: "none",

                textDecoration: "none",
              },
            },
            tickLabels: {
              hideMinMax: true,
              defaultTickLineConfig: {
                color: "#fff",
              },
            },
          }}
          value={value}
        />
      </div>
      <p className=" text-sm font-medium mx-auto">
        Expense Predictability Score{" "}
        <span
          style={{
            color: getColor(status),
          }}
          className=" font-bold"
        >
          {status !== "Insufficient data" ? status : "--"}{" "}
        </span>
      </p>
    </div>
  );
}

export default Gauge;
